import React, { useEffect, useState } from 'react';
import { getBranchesMssql } from 'api/dashboard';
import './BhimaFilters.css';

const SCHEME_ALL = 'all';
const SCHEME_GOLD = 'A';
const SCHEME_VALUE = 'B';

export function BhimaDashboardFilters({ filter, onChange }) {
    const [branches, setBranches] = useState([]);

    useEffect(() => {
        getBranchesMssql()
            .then((data) => setBranches(Array.isArray(data?.branches) ? data.branches : []))
            .catch(() => setBranches([]));
    }, []);

    const handleStartDateChange = (event) => {
        onChange({ ...filter, startDate: event.target.value || '' });
    };

    const handleEndDateChange = (event) => {
        onChange({ ...filter, endDate: event.target.value || '' });
    };

    const handleBranchChange = (event) => {
        onChange({ ...filter, branch: event.target.value || '' });
    };

    const handleSchemeTypeChange = (schemeType) => {
        onChange({ ...filter, schemeType });
    };

    const preventTypingKeyDown = (event) => {
        const allowedKeys = ['Tab', 'Escape', 'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Enter'];
        if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey || event.altKey) return;
        event.preventDefault();
    };

    return (
        <div className="bhima-filters">
            <label className="bhima-filter-item">
                <span className="bhima-filter-item-label">Start date</span>
                <input
                    type="date"
                    className="bhima-filter-input"
                    value={filter.startDate || ''}
                    onChange={handleStartDateChange}
                    onKeyDown={preventTypingKeyDown}
                    onPaste={(e) => e.preventDefault()}
                />
            </label>
            <label className="bhima-filter-item">
                <span className="bhima-filter-item-label">End date</span>
                <input
                    type="date"
                    className="bhima-filter-input"
                    value={filter.endDate || ''}
                    onChange={handleEndDateChange}
                    onKeyDown={preventTypingKeyDown}
                    onPaste={(e) => e.preventDefault()}
                />
            </label>
            <label className="bhima-filter-item">
                <span className="bhima-filter-item-label">Branch</span>
                <select
                    className="bhima-filter-select"
                    value={filter.branch || ''}
                    onChange={handleBranchChange}
                >
                    <option value="">All</option>
                    {branches.map((branchCode) => (
                        <option key={branchCode} value={branchCode}>
                            {branchCode}
                        </option>
                    ))}
                </select>
            </label>
            <span className="bhima-filter-item-label bhima-filter-scheme-label">Scheme type</span>
            <label className="bhima-radio-label">
                <input
                    type="radio"
                    name="schemeType"
                    checked={(filter.schemeType || SCHEME_ALL) === SCHEME_GOLD}
                    onChange={() => handleSchemeTypeChange(SCHEME_GOLD)}
                    className="bhima-radio"
                />
                <span>Gold deposit</span>
            </label>
            <label className="bhima-radio-label">
                <input
                    type="radio"
                    name="schemeType"
                    checked={(filter.schemeType || SCHEME_ALL) === SCHEME_VALUE}
                    onChange={() => handleSchemeTypeChange(SCHEME_VALUE)}
                    className="bhima-radio"
                />
                <span>Value deposit</span>
            </label>
            <label className="bhima-radio-label">
                <input
                    type="radio"
                    name="schemeType"
                    checked={(filter.schemeType || SCHEME_ALL) === SCHEME_ALL}
                    onChange={() => handleSchemeTypeChange(SCHEME_ALL)}
                    className="bhima-radio"
                />
                <span>All schemes</span>
            </label>
        </div>
    );
}

export function buildBulkFilterPayload(filter) {
    const schemeType = filter?.schemeType ?? SCHEME_ALL;
    const scheme_type = schemeType === SCHEME_ALL ? [SCHEME_GOLD, SCHEME_VALUE] : [schemeType];
    return {
        filter: {
            dateFilter: {
                startDate: filter?.startDate ?? '',
                endDate: filter?.endDate ?? ''
            },
            brachFlter: filter?.branch ?? '',
            scheme_type
        }
    };
}
